import RelationsTree from "../../features/relations-tree";

const RelationPage = ({ match }) => <RelationsTree match={match} />;

export default RelationPage;
